import { Box } from "@mui/material";
import { useContextProvider } from "../../components/page-context/ContextProvider";
import StandardSuppliersLibrary from "../../sidemenu-pages/StandardSuppliersLibrary";

const ProductEpdDppLibrary = () => {
  const { selectedLanguage } = useContextProvider();
  return (
    <Box sx={{ padding: 1 }}>
      <StandardSuppliersLibrary
        selectedLanguage={selectedLanguage}
        pageType={"supplier"}
      />
    </Box>
  );
};
export default ProductEpdDppLibrary;
